







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Chart from '@/components/organizationDashboard/charts/Chart.vue';
import LineBar from '@/components/organizationDashboard/charts/Line.vue';
import { ProjectCostAggregation } from '@/repository/@types/Organization';
import dayjs from 'dayjs';

@Component({
  components: {
    Chart,
    LineBar,
  },
})
export default class ProjectManagementCard extends Vue {
  private moneyChartBackgroundColor = ['#7CA5FD', 'rgba(76, 132, 253,0.05)'];
  private timeChartBackgroundColor = ['rgba(252, 79, 168,.7)', 'rgba(252, 79, 168,0.05)'];
  private moneyLineBackgroundColor = 'rgba(76, 132, 253, 1)';
  private timeLineBackgroundColor = 'rgba(252, 79, 168, 1)';
  private moneyLineBorderColor = 'rgba(76, 132, 253, 0.5)';
  private timeLineBorderColor = 'rgba(252, 79, 168, 0.5)';
  private thisMonth: string = dayjs().format('YYYYMM');

  @Prop({ required: true })
  private projectCostAggregations!: ProjectCostAggregation[];

  private get thisMonthScheduledBudget() {
    const thisMonthAggregation = this.projectCostAggregations.find((v) => v.aggregationMonth === this.thisMonth);
    return thisMonthAggregation?.scheduledBudget ?? 0;
  }

  private get thisMonthUsedBudget() {
    const thisMonthAggregation = this.projectCostAggregations.find((v) => v.aggregationMonth === this.thisMonth);
    return thisMonthAggregation?.usedBudget ?? 0;
  }

  private get thisMonthScheduledManHour() {
    const thisMonthAggregation = this.projectCostAggregations.find((v) => v.aggregationMonth === this.thisMonth);
    return thisMonthAggregation?.scheduledManHour ?? 0;
  }

  private get thisMonthUsedManHour() {
    const thisMonthAggregation = this.projectCostAggregations.find((v) => v.aggregationMonth === this.thisMonth);
    return thisMonthAggregation?.usedManHour ?? 0;
  }

  private get usedBudgetHalfYear() {
    return [
      this.projectCostAggregations[0]?.usedBudget ?? 0,
      this.projectCostAggregations[1]?.usedBudget ?? 0,
      this.projectCostAggregations[2]?.usedBudget ?? 0,
      this.projectCostAggregations[3]?.usedBudget ?? 0,
      this.projectCostAggregations[4]?.usedBudget ?? 0,
      this.projectCostAggregations[5]?.usedBudget ?? 0,
    ]
  }

  private get usedManHourHalfYear() {
    return [
      this.projectCostAggregations[0]?.usedManHour ?? 0,
      this.projectCostAggregations[1]?.usedManHour ?? 0,
      this.projectCostAggregations[2]?.usedManHour ?? 0,
      this.projectCostAggregations[3]?.usedManHour ?? 0,
      this.projectCostAggregations[4]?.usedManHour ?? 0,
      this.projectCostAggregations[5]?.usedManHour ?? 0,
    ]
  }

  // 予算チャート用のデータ
  private get budgetChartData(): Chart.ChartData {
    return {
      labels: ['1', '2', '3', '4', '5', '6'], // 見えないラベルなので固定値。値に意味は無い。
      datasets: [
        {
          label: 'temperature',
          data: this.usedBudgetHalfYear,
          backgroundColor: this.moneyLineBackgroundColor,
          borderColor: this.moneyLineBorderColor,
          fill: false
        },
      ],
    }
  };

  private get budgetChartOptions(): Chart.ChartOptions {
    return {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false, fullWidth: false, reverse: false, rtl: false },
      tooltips: { enabled: false },
      plugins: {
      datalabels: {
          // hide datalabels for all datasets
          display: false
        },
      },
      scales: {
        // 軸設定
        xAxes: [
          // Ｘ軸設定
          {
            scaleLabel: {
              // 軸ラベル
              display: false, // 表示設定
            },
            gridLines: { display: false },
            ticks: {
              // 目盛り
              min: 0, // 最小値
              max: 5, // 最大値
              stepSize: 1, // 軸間隔
              fontColor: 'white', // 目盛りの色
              fontSize: 5
            }
          },
        ],
        yAxes: [
          // Ｙ軸設定
          {
            scaleLabel: {
              // 軸ラベル
              display: false, // 表示の有無
              // フォントサイズ
            },
            gridLines: {display: false},
            ticks: {
              // 目盛り
              min: 0, // 最小値
              max: Math.max.apply(null, this.usedBudgetHalfYear), // 最大値
              stepSize: 10, // 軸間隔
              fontColor: 'white', // 目盛りの色
              fontSize: 5
            },
          },
        ],
      },
    }
  };

  // 工数チャート用のデータ
  private get manHourChartData(): Chart.ChartData {
    return {
      labels: ['1', '2', '3', '4', '5', '6'], // 見えないラベルなので固定値。値に意味は無い。
      datasets: [
        {
          label: 'temperature',
          data: this.usedManHourHalfYear,
          backgroundColor: this.timeLineBackgroundColor,
          borderColor: this.timeLineBorderColor,
          fill: false
        },
      ],
    }
  };

  private get manHourChartOptions(): Chart.ChartOptions {
    return {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false, fullWidth: false, reverse: false, rtl: false },
      tooltips: { enabled: false },
      plugins: {
      datalabels: {
          // hide datalabels for all datasets
          display: false
        },
      },
      scales: {
        // 軸設定
        xAxes: [
          // Ｘ軸設定
          {
            scaleLabel: {
              // 軸ラベル
              display: false, // 表示設定
            },
            gridLines: { display: false },
            ticks: {
              // 目盛り
              min: 0, // 最小値
              max: 5, // 最大値
              stepSize: 1, // 軸間隔
              fontColor: 'white', // 目盛りの色
              fontSize: 5
            }
          },
        ],
        yAxes: [
          // Ｙ軸設定
          {
            scaleLabel: {
              // 軸ラベル
              display: false, // 表示の有無
              // フォントサイズ
            },
            gridLines: {display: false},
            ticks: {
              // 目盛り
              min: 0, // 最小値
              max: Math.max.apply(null, this.usedManHourHalfYear), // 最大値
              stepSize: 10, // 軸間隔
              fontColor: 'white', // 目盛りの色
              fontSize: 5
            },
          },
        ],
      },
    }
  };
}
